// extracted by mini-css-extract-plugin
export default {"searchResultsStats":"sZA1hbZqPF7ceUUrnmSH","variant":"_Egfb7YFQdnUaM0_D2Wk"};